import AnnouncementContent from './AnnouncementContent.jsx';
import AnnouncementDetailContent from './AnnouncementDetailContent.jsx';

export {
  AnnouncementContent,
  AnnouncementDetailContent
};



// WEBPACK FOOTER //
// ./components/users/sub-view/announcement-content/index.js